// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3gLZt","name":"Header_name__3cj0U","birthday":"Header_birthday__1EAym","skeleton":"Header_skeleton__1y3aR"};